export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-primary-800 text-white/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-white text-base"></i>
              </div>
              <span className="font-heading font-bold text-lg text-white">91影视看片下载</span>
            </div>
            <p className="text-sm leading-relaxed text-white/60 mb-6">
              专业的<strong className="text-white/90">安卓影视APP</strong>下载平台，提供安全可靠的<strong className="text-white/90">看片软件下载</strong>服务。
              聚合海量<strong className="text-white/90">免费影视</strong>资源，手机追剧首选工具，随时随地高清观影。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/60 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/60 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-white mb-5">快速导航</h3>
            <ul className="space-y-3">
              {[
                { label: 'APP下载', href: '#app' },
                { label: '核心优势', href: '#features' },
                { label: '热门话题', href: '#topics' },
                { label: '下载排行', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                    className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-white mb-5">内容分类</h3>
            <ul className="space-y-3">
              {['热门电视剧', '最新电影', '综艺娱乐', '动漫番剧', '纪录片', '日韩剧场'].map((item) => (
                <li key={item}>
                  <a href="#cards" onClick={(e) => { e.preventDefault(); scrollTo('#cards'); }} className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-white mb-5">合作伙伴</h3>
            <p className="text-sm text-white/50 leading-relaxed">
              更多优质合作伙伴正在陆续接入中，敬请期待。如有合作意向，欢迎通过
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="text-primary-300 hover:text-white cursor-pointer">联系我们</a>
              页面与我们沟通。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">
              &copy; 2024 91影视看片下载官网. 本站仅提供APP下载渠道指引，所有影视内容版权归原权利人所有。
            </p>
            <div className="flex items-center gap-6">
              <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">常见问答</a>
              <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('#about'); }} className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">关于我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}